const ThemeMenu = ({ setShowThemeMenu }) => {
  const changeTheme = (mode) => {
    if (mode === "system") {
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        localStorage.setItem("data-bs-theme", "dark");
        window.dispatchEvent(new Event("themeChange"));
      } else {
        localStorage.setItem("data-bs-theme", "light");
        window.dispatchEvent(new Event("themeChange"));
      }
    } else {
      localStorage.setItem("data-bs-theme", mode);
      window.dispatchEvent(new Event("themeChange"));
    }
  };
  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px show theme-mode-menu"
      data-kt-menu="true"
      data-kt-element="theme-mode-menu"
      data-popper-placement="bottom-end"
    >
      {/*begin::Menu item*/}
      <div className="menu-item px-3 my-0">
        <div
          style={{ cursor: "pointer" }}
          className="menu-link px-3 py-2"
          data-kt-element="mode"
          data-kt-value="light"
          onClick={() => {
            changeTheme("light");
            setShowThemeMenu(false);
          }}
        >
          <span className="menu-icon" data-kt-element="icon">
            <i className="ki-duotone ki-night-day fs-2">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
              <span className="path5"></span>
              <span className="path6"></span>
              <span className="path7"></span>
              <span className="path8"></span>
              <span className="path9"></span>
              <span className="path10"></span>
            </i>{" "}
          </span>
          <span className="menu-title">Light</span>
        </div>
      </div>
      {/*end::Menu item*/}

      {/*begin::Menu item*/}
      <div className="menu-item px-3 my-0">
        <div
          style={{ cursor: "pointer" }}
          className="menu-link px-3 py-2"
          data-kt-element="mode"
          data-kt-value="dark"
          onClick={() => {
            changeTheme("dark");
            setShowThemeMenu(false);
          }}
        >
          <span className="menu-icon" data-kt-element="icon">
            <i className="ki-duotone ki-moon fs-2">
              <span className="path1"></span>
              <span className="path2"></span>
            </i>{" "}
          </span>
          <span className="menu-title">Dark</span>
        </div>
      </div>
      {/*end::Menu item*/}

      {/*begin::Menu item*/}
      <div className="menu-item px-3 my-0">
        <div
          style={{ cursor: "pointer" }}
          className="menu-link px-3 py-2"
          data-kt-element="mode"
          data-kt-value="system"
          onClick={() => {
            changeTheme("system");
            setShowThemeMenu(false);
          }}
        >
          <span className="menu-icon" data-kt-element="icon">
            <i className="ki-duotone ki-screen fs-2">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </i>{" "}
          </span>
          <span className="menu-title">System</span>
        </div>
      </div>
      {/*end::Menu item*/}
    </div>
  );
};

export default ThemeMenu;
